import SrDatetime from "./SrDatetime.vue";

SrDatetime.install = function(Vue) {
  Vue.component(SrDatetime.name, SrDatetime);
};

export default SrDatetime;


// WEBPACK FOOTER //
// ./packages/SrDatetime/index.js